'use client';

import { useState } from 'react';
import { useInterval } from 'react-use';
import useVelocityStore from '../../stores/VelocityStore/useVelocityStore';

const useRecentTimeouts = (basePollingRate: number) => {
	const velocityClient = useVelocityStore((s) => s.velocityClient.client);
	const [timeoutCount, setTimeoutCount] = useState(0);

	// keep timeout count from last 10 polls
	useInterval(() => {
		if (velocityClient?.txSender) {
			setTimeoutCount(
				Math.max(0, velocityClient.txSender.getTimeoutCount() - timeoutCount)
			);
		}
	}, basePollingRate * 10);

	return timeoutCount;
};

export default useRecentTimeouts;
